import {useCallback} from "react";
import {useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";


export default function useMatchersSkusCreateLine() {
    const lineName = useSignal('')
    const isLoading = useSignal(false)

    const { showToast } = useAppToast()

    const handleLineName = useCallback(newValue => {
       lineName.value = newValue
    }, [])

    const handleSubmit = useCallback(async (brandID) => {
       try {
          const data = {
             lineName: lineName.value,
             brandID: brandID
          }
          isLoading.value = true
          const response = await postSubmit(`${BACKEND_APIS.SKU_DATA}/update-line`, data);
          postSubmit(`${BACKEND_APIS.MATCHERS}/notifications/create-line`, data)
             .catch(() => showToast.error('Error Send notification create'))
          showToast.success('Line Created!')
          lineName.value = ''
          return response
       } catch (error) {
          showToast.error('Error creating line')
          throw error
       } finally {
          isLoading.value = false
       }
    }, []);

    const reset = useCallback(() => {
       lineName.value = ''
    }, [])

    return {
       isLoading: isLoading.value,
       lineName: lineName.value,

       handleLineName,
       handleSubmit,
       reset
    }
}
